import styled from "styled-components";
import media from "helpers/media";

export const Container = styled.div`
  display: flex;
  ${media.SM`
  flex-direction: column;
`};
  gap: 2rem;
  padding: 1.6rem 0;
  width: 100%;
`;
